import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';
import { Loader, type LoaderOptions } from '@googlemaps/js-api-loader';

export const GOOGLE_MAPS_JS_API_LOADER = new InjectionToken<Loader>(
  'GoogleMapsJsApiLoader',
);

export function provideGoogleMapsJsApiLoader(
  options: LoaderOptions,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: GOOGLE_MAPS_JS_API_LOADER,
      useFactory: () => new Loader(options),
    },
  ]);
}
